import { SIZE_LG, SIZE_MD, SIZE_SM } from '../../config/constants';

export const SWITCH_BASE_CLASS = 'custom-control custom-switch';
export const SWITCH_SIZES = [
  SIZE_SM,
  SIZE_MD,
  SIZE_LG,
];
export const SWITCH_TYPE_RADIO = 'radio';
export const SWITCH_TYPE_CHECKBOX = 'checkbox';
export const SWITCH_TYPES = [
  SWITCH_TYPE_CHECKBOX,
  SWITCH_TYPE_RADIO,
];
